<template>
  <div :class="c()">
    <survey-finish
      v-if="success"
      :html="success"
      :text-button="textButton"
      :href="finishLink"
    />
    <div
      v-else
      :class="c('inner')"
    >
      <survey-steps
        :class="c('steps')"
        :step="step"
        :total-steps="totalSteps"
      />
      <div>
        <form
          v-if="!isPersonalDataSaved"
          :class="c('personal')"
          @submit.prevent="savePersonal"
        >
          <h2 :class="c('title')">
            {{ localisation.text_fill_data }}
          </h2>
          <answer-input
            v-model="user.name"
            type="text"
            placeholder="Name"
            required
          />
          <answer-input
            v-model="user.email"
            type="email"
            placeholder="Email"
            required
          />
          <button
            type="submit"
            :class="['btn btn__primary']"
          >
            {{ textNext }}
          </button>
        </form>
        <div v-else>
          <form
            v-if="questions"
            :class="c('content')"
            @submit="handleSubmit"
          >
            <survey-field
              v-if="currentQuestion"
              :question-id="currentQuestion.id"
              :text="currentQuestion.text"
              :options="currentQuestion.options"
              :type="currentQuestion.type"
              @answer="updateAnswer"
            />
            <button
              type="submit"
              :class="['btn btn__primary', c('submit')]"
              :disabled="disabledButton"
            >
              {{ textNext }}
            </button>
          </form>
          <p v-else>
            There's nothing here
          </p>
        </div>
      </div>
      <survey-pyramid
        :step="Number(step)"
        :class="c('pyramid')"
      />
    </div>
  </div>
</template>

<script>
import {cn} from '@/app/js/classname'
import SurveyPyramid from '@/app/vue/survey/survey-pyramid.vue'
import SurveyField from '@/app/vue/survey/survey-field.vue'
import SurveySteps from '@/app/vue/survey/survey-steps.vue'
import SurveyFinish from '@/app/vue/survey/survey-finish.vue'
import {saveSurvey} from '@/app/vue/survey/api'
import AnswerInput from '@/app/vue/survey/answer/answer-input.vue'

const c = cn('survey')
export default {
  name: 'SurveyApp',
  components: {AnswerInput, SurveyFinish,  SurveySteps, SurveyField, SurveyPyramid},
  props: {
    name: {
      type: String,
      default: null
    },
    questions: {
      type: Array,
      default: () => ([])
    },
    surveyId: {
      type: String,
      default: null
    },
    localisation: {
      type: Object,
      default: null
    },
    finishLink: {
      type: String,
      default: null
    },
    anonym: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      step: 0,
      totalSteps: this.questions.length,
      answers: { },
      success: null,
      error: null,
      disabledButton: false,
      user: {
        name: '',
        email: ''
      },
      isPersonalDataSaved: this.anonym
    }
  },
  computed: {
    currentQuestion() {
      return this.questions ? this.questions[this.step] : null
    },
    textNext() {
      return this.localisation?.text_next || 'next'
    },
    textButton() {
      return this.localisation?.text_button || 'back to catalog'
    }
  },
  watch: {
    step() {
      if (this.step === this.totalSteps) {
        this.saveSurveyData()
      }
    },
  },
  methods: {
    c,
    handleSubmit(event) {
      event.preventDefault()
      if (this.step < this.totalSteps) {
        this.step += 1
      }
      const form = event.target
      form.reset()
    },
    updateAnswer({question, answer}) {
      this.answers[this.step] = {
        'question': question,
        'answer': answer
      }
    },
    savePersonal() {
      this.isPersonalDataSaved = true
    },
    async saveSurveyData() {
      this.disabledButton = true
      const formData = new FormData()
      formData.set('info', JSON.stringify(this.answers))
      formData.set('name', this.name)
      formData.set('survey_id', this.surveyId)
      formData.set('user_name', this.user.name)
      formData.set('user_email', this.user.email)
      const {data} = await saveSurvey(formData)
      if (data.success) {
        this.success = data.html
      } else {
        this.error = data.error
      }
      this.disabledButton = false
    }
  }
}
</script>

<style lang="scss">
.survey {
  padding: 8px 0 30px;

  &__inner {
    display: grid;
    grid-template-columns: 1fr 295px;
    column-gap: 128px;
  }

  &__submit {
    margin-top: 16px;
    width: 100%;
  }

  &__content {
    padding: 20px 0;
  }

  &__personal {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  &__title {
    margin: 0;
  }

  @media screen and (max-width: 1024px) {
    &__inner {
      column-gap: 50px;
    }
  }

  @media screen and (min-width: 769px) {
    &__steps {
      display: none;
    }
  }

  @media screen and (max-width: 768px) {
    padding-top: 24px;

    &__inner {
      grid-template-columns: 1fr;
    }

    &__pyramid {
      display: none;
    }
  }
}
</style>
